import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react";

export interface PageHeader {
  title: string;
  subtitle?: string;
}

type PageHeaderContextValue = {
  header: PageHeader;
  setHeader: (h: PageHeader) => void;
};

const PageHeaderContext = createContext<PageHeaderContextValue | null>(null);

export function PageHeaderProvider({
  children,
  defaultHeader,
}: {
  children: ReactNode;
  defaultHeader: PageHeader;
}) {
  const [header, setHeader] = useState<PageHeader>(defaultHeader);
  return (
    <PageHeaderContext.Provider value={{ header, setHeader }}>
      {children}
    </PageHeaderContext.Provider>
  );
}

export function usePageHeader(): PageHeader {
  const ctx = useContext(PageHeaderContext);
  return ctx?.header ?? { title: "Foreman" };
}

export function useSetPageHeader(title: string, subtitle?: string): void {
  const ctx = useContext(PageHeaderContext);
  useEffect(() => {
    ctx?.setHeader({ title, subtitle });
  }, [ctx, title, subtitle]);
}
